import { useEffect, useState } from "react";
import { Switch } from "../components/ui/switch";
import axios, { API } from "@/lib/apiClient";
import { toast } from "sonner";

export const AutoRescanToggle = ({ auditId, brandName, tier = "agency" }) => {
  const [enabled, setEnabled] = useState(false);
  const [hourly, setHourly] = useState(false);
  const [loading, setLoading] = useState(false);
  const canHourly = tier === "sovereign_defense";

  useEffect(() => {
    axios
      .get(`${API}/watches/mine`)
      .then((res) => {
        const watch = res.data.find((w) => w.brand_name === brandName);
        if (watch) {
          setEnabled(watch.enabled);
          setHourly(!!watch.hourly);
        }
      })
      .catch(() => {});
  }, [brandName]);

  const toggle = async (checked) => {
    setLoading(true);
    try {
      await axios.post(`${API}/watches/toggle`, { audit_id: auditId, enabled: checked, hourly });
      setEnabled(checked);
      toast.success(checked ? "Automated Audit enabled." : "Automated Audit disabled.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not update Auto Re-Scan.");
    } finally {
      setLoading(false);
    }
  };

  const toggleHourly = async (checked) => {
    setLoading(true);
    try {
      await axios.post(`${API}/watches/toggle`, { audit_id: auditId, enabled, hourly: checked });
      setHourly(checked);
      toast.success(checked ? "Hourly Signal Probes enabled." : "Hourly Signal Probes disabled - back to weekly.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not update probe frequency.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between rounded-md border border-surface-border bg-obsidian px-4 py-3" data-testid="auto-rescan-toggle">
        <div>
          <p className="text-sm font-semibold text-white">Automated Audit</p>
          <p className="text-xs text-slate-500">Auto re-scan this brand and send a Signal Change alert if the score drops more than 5 points.</p>
        </div>
        <Switch checked={enabled} disabled={loading} onCheckedChange={toggle} data-testid="auto-rescan-switch" />
      </div>
      {canHourly && (
        <div className="flex items-center justify-between rounded-md border border-warning-amber/30 bg-warning-amber/5 px-4 py-3" data-testid="hourly-probes-toggle">
          <div>
            <p className="text-sm font-semibold text-warning-amber">Hourly Signal Probes</p>
            <p className="text-xs text-slate-500">Sovereign Defense: re-scan every hour instead of weekly (optional).</p>
          </div>
          <Switch checked={hourly} disabled={loading || !enabled} onCheckedChange={toggleHourly} data-testid="hourly-probes-switch" />
        </div>
      )}
    </div>
  );
};
